<template>
  <div class="container main has-submenu" :class="{ fullwidth : !loggedIn }">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-info">
      <div class="wrapper">
        <div style="margin-bottom: 16px;">
          <!-- <img src="../../../static/img/bubbles.png" class="img-responsive bubble"> -->
          <div class="welcome">
            <h3>Welcome, {{firstName}} {{lastName}}</h3>
            <h4>Topup, pay bills, send and receive LajanCash online, easily and securely</h4>
            <h4>Link your wallet or debit/credit card to get started</h4>
          </div>
        </div>
        <div class="banner">
                <div class="addSection">
                    <router-link to="/account/link/wallets" style="margin-bottom: 20px;">
                        <span class="link" id="linkLajancash">
                              <img src="../../../static/img/wallet.png" class="img-responsive" style="margin-top:10px;" />
                              <p style="padding-top: 5px;">Link your wallets account</p>
                        </span>
                    </router-link>
                    <!-- <a @click="addCards"> -->
                    <router-link to="/account/link/cards">
                        <span class="link">
                          <svg class="generic-card-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 32" width="100px" height="100px" fill="#009CDE"><path class="generic-card-icon-stroke" d="M36.62,23.13H32.29a1.38,1.38,0,0,1-1.38-1.38V18.54a1.38,1.38,0,0,1,1.38-1.38h4.33A1.39,1.39,0,0,1,38,18.54v3.21A1.39,1.39,0,0,1,36.62,23.13Zm-4.33-5a.38.38,0,0,0-.38.38v3.21a.39.39,0,0,0,.38.38h4.33a.39.39,0,0,0,.38-.38V18.54a.38.38,0,0,0-.38-.38Z"></path><path class="generic-card-icon-stroke" d="M41.51,30H4.13A2.14,2.14,0,0,1,2,27.85V4.66A2.14,2.14,0,0,1,4.13,2.5H41.51a2.14,2.14,0,0,1,2.13,2.16V6.45a.5.5,0,1,1-1,0V4.66A1.14,1.14,0,0,0,41.51,3.5H4.13A1.14,1.14,0,0,0,3,4.66V27.85A1.14,1.14,0,0,0,4.13,29H41.51a1.14,1.14,0,0,0,1.13-1.16V11h-35a.5.5,0,1,1,0-1H43.13a.5.5,0,0,1,.5.5V27.85A2.14,2.14,0,0,1,41.51,30Z"></path><path class="generic-card-icon-stroke" d="M25.9,17.15H7.57a.5.5,0,0,1,0-1H25.9a.5.5,0,0,1,0,1Z"></path>
                            <!-- <h5>Link your credits / debits card</h5> -->
                          </svg>
                          <p class="svg">Link your credit card</p>
                        </span>
                    <!-- </a> -->
                    </router-link>
                    <!-- <a @click="addBank">
                        <span class="link">
                              <svg class="generic-bank-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 32" width="100px" height="100px" fill="#009CDE"><path class="generic-bank-icon-stroke" d="M32.71,10,17.23,2.79a.5.5,0,0,0-.44,0L2.32,10.05a.5.5,0,0,0,.22.95H6.14V21.89a.5.5,0,1,0,1,0V11H12.8V24a.5.5,0,0,0,.5.5l16.37.09v2.12a.5.5,0,0,0,.5.5h1.05v1.33H3V27.18H4.05a.5.5,0,0,0,.5-.5V24.85H9.88a.5.5,0,0,0,0-1H4.05a.5.5,0,0,0-.5.5v1.83H2.5a.5.5,0,0,0-.5.5V29a.5.5,0,0,0,.5.5H31.72a.5.5,0,0,0,.5-.5V26.68a.5.5,0,0,0-.5-.5H30.67V24.06a.5.5,0,0,0-.5-.5L13.8,23.46V11H19V22a.5.5,0,0,0,1,0V10.5a.5.5,0,0,0-.5-.5H4.66L17,3.8,30.25,10H27.5a.5.5,0,0,0-.5.5V22a.5.5,0,0,0,1,0V11h4.5a.5.5,0,0,0,.21-1Z"></path>
                              </svg>
                              <p class="svg">Link your Banks account</p>
                        </span>
                    </a> -->
                </div>
            </div>
                <!-- Statart modal add bank -->
        <!-- <div id="add_bank" class="modal" data-easein="pulse" tabindex="-1" role="dialog" aria-labelledby="addbankLabel" aria-hidden="false">
            <div class="payment panel panel-default">
            <div class="panel-heading text-center">
              <svg class="generic-bank-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 32" width="60px" height="60px" fill="#009CDE"><path class="generic-bank-icon-stroke" d="M32.71,10,17.23,2.79a.5.5,0,0,0-.44,0L2.32,10.05a.5.5,0,0,0,.22.95H6.14V21.89a.5.5,0,1,0,1,0V11H12.8V24a.5.5,0,0,0,.5.5l16.37.09v2.12a.5.5,0,0,0,.5.5h1.05v1.33H3V27.18H4.05a.5.5,0,0,0,.5-.5V24.85H9.88a.5.5,0,0,0,0-1H4.05a.5.5,0,0,0-.5.5v1.83H2.5a.5.5,0,0,0-.5.5V29a.5.5,0,0,0,.5.5H31.72a.5.5,0,0,0,.5-.5V26.68a.5.5,0,0,0-.5-.5H30.67V24.06a.5.5,0,0,0-.5-.5L13.8,23.46V11H19V22a.5.5,0,0,0,1,0V10.5a.5.5,0,0,0-.5-.5H4.66L17,3.8,30.25,10H27.5a.5.5,0,0,0-.5.5V22a.5.5,0,0,0,1,0V11h4.5a.5.5,0,0,0,.21-1Z"></path>
              </svg>
              <h4 style="margin-top:0;"> Add a bank account
              </h4>
            </div>
            <div class="panel-body">
              <form action="" @submit="addNewBank" id="payment-form">
                <div class="errors"></div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Country</label>
                      <select v-model="country" class="form-control input-lg input-outline" id="country" data-stripe="country" required>
                        <option value="US">United States</option>
                        <option value="AU">Australia</option>
                        <option value="AT">Austria</option>
                        <option value="BE">Belgium</option>
                        <option value="BR">Brazil</option>
                        <option value="CA">Canada</option>
                        <option value="DK">Denmark</option>
                        <option value="FI">Finland</option>
                        <option value="FR">France</option>
                        <option value="DE">Germany</option>
                        <option value="HK">Hong Kong</option>
                        <option value="IE">Ireland</option>
                        <option value="IT">Italy</option>
                        <option value="JP">Japan</option>
                        <option value="LU">Luxembourg</option>
                        <option value="MX">Mexico</option>
                        <option value="NZ">New Zealand</option>
                        <option value="NL">Netherlands</option>
                        <option value="NO">Norway</option>
                        <option value="PT">Portugal</option>
                        <option value="SG">Singapore</option>
                        <option value="ES">Spain</option>
                        <option value="SE">Sweden</option>
                        <option value="CH">Switzerland</option>
                        <option value="HT">Haiti</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Currency</label>
                      <select v-model="currency" class="form-control input-lg input-outline" id="currency" data-stripe="currency" required>
                        <option value="usd">USD</option>
                        <option value="aud">AUD</option>
                        <option value="brl">BRL</option>
                        <option value="cad">CAD</option>
                        <option value="eur">EUR</option>
                        <option value="gbp">GBP</option>
                        <option value="hkd">HKD</option>
                        <option value="jpy">JPY</option>
                        <option value="mxn">MXN</option>
                        <option value="nzd">NZD</option>
                        <option value="sgd">SGD</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Full Legal Name</label>
                      <input v-model="name" class="form-control input-lg account_holder_name" id="account_holder_name" type="text" data-stripe="account_holder_name" placeholder="Jane Doe" autocomplete="off" required style="border: 2px solid #9fc7c0;">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Account Type</label>
                      <select v-model="accountType" class="form-control input-lg account_holder_type input-outline" id="account_holder_type" data-stripe="account_holder_type" required>
                        <option value="individual">Individual</option>
                        <option value="company">Company</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6" id="routing_number_div">
                    <div class="form-group">
                      <label id="routing_number_label">Routing Number</label>
                      <input v-model="routing"  class="form-control input-lg bank_account input-outline" id="routing_number" type="text" size="12" data-stripe="routing_number" placeholder="111000025" autocomplete="off" required minlength="9" maxlength="9" style="border: 2px solid #9fc7c0;">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label id="account_number_label">Account Number</label>
                      <input class="form-control input-lg bank_account input-outline" v-model="number" id="account_number" type="text" size="20" data-stripe="account_number" placeholder="000123456789" autocomplete="off" required style="border: 2px solid #9fc7c0;">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-lg btn-block btn-success submit" type="submit">Add bank account</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>  -->
        <!-- modal End Add bank -->
        <!-- <card></card> -->
      </div>
    </div>
  </div>
  </div>
</div>
</template>
<script>
  /* global Stripe */
  import {HTTP, account} from '../../services/account-services.js'
  import { default as swal } from 'sweetalert2'
  import Cards from '../Cards/Cards.vue'
  export default {
    name: 'LinkAccount',
    components: {
      card: Cards
    },
    data() {
      return {
        country: '',
        currency: 0,
        name: '',
        accountType: '',
        routing: '',
        number: '',
        account: {},
        stripeID: '',
        firstName: localStorage.getItem('firstName'),
        lastName: localStorage.getItem('lastName')
      }
    },
    methods: {
      addBank() {
        $('#add_bank').modal()
      },
      addNewBank() {
        console.log('Add bank account...')
        let name = this.name
        let number = this.number
        let country = this.country
        let currency = this.currency
        let accountType = this.accountType
        let routing = this.routing
        let token = localStorage.getItem('authToken')
        let accountID = localStorage.getItem('userId')
        let url = '/accounts/' + accountID + '/banks?access_token=' + token
        HTTP.post(url,
          {
            object: 'bank_account',
            account_number: number,
            account_holder_name: name,
            country: country,
            currency: currency,
            account_holder_type: accountType,
            routing_number: routing
          }).then(function(response) {
          // this.router.push({ name: '/account'})
          this.$route.go('/account')
          $('#add_bank').modal('hide')
          swal(
            'Success !',
            'Your Bank has been added succesfully!',
            'success'
          )
        }).catch(function(e) {
          console.log(e)
        })
      }

    },
    mounted() {
      let app = this
      account().then(function(response) {
        app.stripeID = response.stripeCustomerId
      }).catch(function(e) {
        console.log(e)
      })
      /* eslint brace-style: [2, "stroustrup"] */
      // Set your Stripe publishable API key here
      Stripe.setPublishableKey('pk_test_1gJfAA34FfdhB6fLqtsJfNCi')
      $(function() {
        var $form = $('#payment-form')
        $form.submit(function(event) {
          // Clear any errors
          $form.find('.has-error').removeClass('has-error')
          // Disable the submit button to prevent repeated clicks:
          $form.find('.submit').prop('disabled', true).html("<i class='fa fa-spinner fa-spin'></i> Adding Bank account")
          // Request a token from Stripe:
          Stripe.bankAccount.createToken($form, stripeResponseHandler)
          // Prevent the form from being submitted:
          return false
        })
        // Switch or hide 'routing number' depending on currency
        $('#currency').change(function() {
          $('#routing_number_div').show()
          $('#account_number_label').text('Account Number').next('input').attr('placeholder', '')
          $('#routing_number').attr('data-stripe', 'routing_number')
          switch (this.value) {
            case 'usd':
              $('#routing_number_label').text('Routing Number').next('input').attr('placeholder', '111000000')
              break
            case 'eur':
              // No routing number needed
              $('#routing_number_div').hide()
              $('#routing_number').removeAttr('data-stripe')
              $('#account_number_label').text('IBAN').next('input').attr('placeholder', 'XX9828737432389')
              break
            case 'cad':
              $('#routing_number_label').text('Transit & Institution Number')
              break
            case 'gbp':
              $('#routing_number_label').text('Sort Code').next('input').attr('placeholder', '12-34-56')
              break
            case 'mxn':
              $('#routing_number_label').text('CLABE')
              break
            case 'aud': case 'nzd':
              $('#routing_number_label').text('BSB').next('input').attr('placeholder', '123456')
              break
            case 'sgd': case 'jpy': case 'brl': case 'hkd':
              $('#routing_number_label').text('Bank / Branch Code')
              break
          }
        })
      })
      function stripeResponseHandler(status, response) {
        var $form = $('#payment-form')
        if (response.error) {
          // Show the errors on the form
          $form.find('.errors').text(response.error.message).addClass('alert alert-danger')
          $form.find('.' + response.error.param).parent('.form-group').addClass('has-error')
          $form.find('button').prop('disabled', false).text('Pay $20')
        }
        else { // Token was created!
          $form.find('.submit').html("<i class='fa fa-check'></i> Account added")

          // Get the token ID:
          var token = response.id
          // Insert the token and name into the form so it gets submitted to the server:
          $form.append($('<input type="hidden" name="stripeToken" />').val(token))
          // Submit the form:
          $form.get(0).submit()
        }
      }
    },
    beforeMount() {
      if (!localStorage.getItem('authToken')) {
        return this.$router.push('/login')
      }
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    props: ['loggedIn']
  }
</script>
<style scoped>
  .container {}

  .wrapper {
    width: 100%;
    font-family: 'Helvetica';
    font-size: 14px;
    margin-top: 30px;
    /*border: 1px solid #CCC;*/
  }
  .banner{
    /*position: fixed;*/
    font-family: 'PayPal-Sans-Big', sans-serif;
  }
  .link {
    width: 320px;
    padding-left:10%;
    border-radius: 6px;
    background-color: transparent;
    border: solid 1px #e1e7eb;
    vertical-align: middle;
    text-align: center;
    display: table-cell;
    cursor: pointer;
  }
  .link:hover {
    border: solid 1px #009bde;
  }
  .link img {
    margin-top :20px;
  }
  .link img, .link svg{
    /*margin: 10px 10px 10px 10px;*/
  }
  .link p {
    margin-left:10px;
    margin-right: 10px;
    font-size:12px;
  }
  .addSection a {
    text-decoration: none;
  }
  .addSection a:hover {
    color: white;
  }
  .intl-tel-input.separate-dial-code .selected-dial-code{
    color:#101010;
  }
  @media (min-width: 480px) {
    .link img {
      margin-left: auto;
      margin-right:auto;
    }
    .welcome {
      text-align: center;
      /* margin-top: -70px; */
    }
    .wrapper {
      padding: 15px;
    }
    .addSection{
      display: flex;
      justify-content: space-around;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media (max-width: 480px) {
    .banner{
      padding: 0.5em 0.5em 0.5em;
    }
    .welcome {
      text-align: center;
      margin-top: -30px;
    }
    .link img{
      margin-left: auto;
      margin-right:auto;
    }
    .addSection {
      display: flex;
      flex-direction: column;
      margin-right: auto;
      margin-left: auto;
      width:100%;
    }
  }

.bubble{
  margin-left: auto;
  margin-right: auto;
}
.svg{
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/LinkAccount.vue